import { useState, useEffect, View, useRef } from 'react';
import { Button, Modal } from "react-bootstrap";
import axios from 'axios';
import CircularProgress from "@mui/material/CircularProgress";
//import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';
import styles from './Forum.css';
import BottomTabNavigation from './BottomTabNavigation';
import Konsensus_Constants from '../constants/index.js';
import { Paper, Stack, Box } from "@mui/material";

export default function Logout() {
  const scrollableDivRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    flarumLogout();
  }, [navigate]);

    async function flarumLogout() {
        Konsensus_Constants.clear();
        navigate('/');
    }

  return (
    <Box sx={{
                 height: "100vh", // Fill viewport height
                 display: "flex",
                 flexDirection: "column",
               }}>
      <Paper elevation={3} sx={{ p: 2 }}>
          <img src={require('../assets/images/banner.png')}
                        style={{
                           height: 77,
                           width: 380,
                           marginBottom: 0,
                        }}/>
      </Paper>
      <Paper elevation={3}
                     sx={{
                       flex: 1,        // fill all available vertical space
                       width: "100%",  // fill horizontal space
                       p: 2,
                     }}>
                     Logged out succesfully!

      </Paper>
      <BottomTabNavigation />
    </Box>
  );
}
const styles2 = {
  container: { padding: 16, paddingTop:10, flex: 1 },
  commentCount: { fontSize: 16, marginBottom: 14 },
  postsContainer: { marginTop: 10 },
  post: { marginBottom: 22 },
  userContainer: { flexDirection: 'row', alignItems: 'center', marginBottom: 4 },
  avatar: { width: 36, height: 36, borderRadius: 18, marginRight: 10, backgroundColor: '#e7f4f6', float: "left", display: 'flex', alignItems: 'center', justifyContent: 'center',},
  avatarPlaceholder: { backgroundColor: '#e7f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#00aaaf', },
  userInfo: { flexDirection: 'column' },
  username: { fontSize: 16, fontWeight: '600' },
  postMeta: { fontSize: 12, color: '#888' },
  hr: { height: 1, backgroundColor: '#ddd', marginTop: 8, marginBottom: 4 },
};